import AppIcon from '../icons/AppIcon'
import Overlay, { OverlayCard } from '../primitives/Overlay'
import styles from './TeamScreen.module.css'

interface TeamLeaveModalProps {
  teamName: string
  onConfirm: () => void
  onCancel: () => void
}

export default function TeamLeaveModal({ teamName, onConfirm, onCancel }: TeamLeaveModalProps) {
  return (
    <Overlay variant="backdrop" onClose={onCancel}>
      <OverlayCard>
        <div className={styles.leaveIcon}>
          <AppIcon icon="mdi:logout" size={26} />
        </div>
        <div className={styles.modalTitle}>Leave {teamName}?</div>
        <p className={styles.modalSub}>
          You&apos;ll drop off the roster and stop contributing RMs to this team. Your logged RMs
          stay with the team. You can rejoin with an invite code.
        </p>
        <div className={styles.leaveBtns}>
          <button type="button" className={styles.leaveCancel} onClick={onCancel}>
            Stay
          </button>
          <button type="button" className={styles.leaveConfirm} onClick={onConfirm}>
            Leave team
          </button>
        </div>
      </OverlayCard>
    </Overlay>
  )
}
